module.exports = __webpack_public_path__ + "img/black.3c16abc5.png";